/* tslint:disable */
/* eslint-disable */
/**
 * Ак Барс Недвижимость API
 * Инструменты разработчика:  [ [Документация API. Swagger](/docs/) ]  [ [Документация API. Redoc](/redoc/) ] [ [Панель администрирования](/admin/) ] [ [Документация Image-Service](/api/attachments/docs/) ]
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface House
 */
export interface House {
    /**
     * 
     * @type {number}
     * @memberof House
     */
    readonly id?: number;
    /**
     * 
     * @type {string}
     * @memberof House
     */
    readonly complexTitle?: string;
    /**
     * 
     * @type {Date}
     * @memberof House
     */
    readonly createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof House
     */
    readonly updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof House
     */
    title?: string | null;
    /**
     * 
     * @type {string}
     * @memberof House
     */
    type?: HouseTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof House
     */
    street?: string | null;
    /**
     * 
     * @type {string}
     * @memberof House
     */
    number?: string | null;
    /**
     * 
     * @type {string}
     * @memberof House
     */
    facing?: string | null;
    /**
     * 
     * @type {string}
     * @memberof House
     */
    material?: string | null;
    /**
     * 
     * @type {string}
     * @memberof House
     */
    buildingState?: string | null;
    /**
     * 
     * @type {number}
     * @memberof House
     */
    developmentStartYear?: number | null;
    /**
     * 
     * @type {number}
     * @memberof House
     */
    developmentStartQuarter?: number | null;
    /**
     * 
     * @type {number}
     * @memberof House
     */
    developmentEndYear?: number | null;
    /**
     * 
     * @type {number}
     * @memberof House
     */
    developmentEndQuarter?: number | null;
    /**
     * 
     * @type {number}
     * @memberof House
     */
    salesStartYear?: number | null;
    /**
     * 
     * @type {number}
     * @memberof House
     */
    salesStartMonth?: number | null;
    /**
     * 
     * @type {number}
     * @memberof House
     */
    salesEndYear?: number | null;
    /**
     * 
     * @type {number}
     * @memberof House
     */
    salesEndMonth?: number | null;
    /**
     * 
     * @type {string}
     * @memberof House
     */
    image?: string | null;
    /**
     * 
     * @type {number}
     * @memberof House
     */
    minFloor?: number | null;
    /**
     * 
     * @type {number}
     * @memberof House
     */
    maxFloor?: number | null;
    /**
     * 
     * @type {number}
     * @memberof House
     */
    complex?: number | null;
}

export function HouseFromJSON(json: any): House {
    return HouseFromJSONTyped(json, false);
}

export function HouseFromJSONTyped(json: any, ignoreDiscriminator: boolean): House {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'complexTitle': !exists(json, 'complexTitle') ? undefined : json['complexTitle'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
        'title': !exists(json, 'title') ? undefined : json['title'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'street': !exists(json, 'street') ? undefined : json['street'],
        'number': !exists(json, 'number') ? undefined : json['number'],
        'facing': !exists(json, 'facing') ? undefined : json['facing'],
        'material': !exists(json, 'material') ? undefined : json['material'],
        'buildingState': !exists(json, 'buildingState') ? undefined : json['buildingState'],
        'developmentStartYear': !exists(json, 'developmentStartYear') ? undefined : json['developmentStartYear'],
        'developmentStartQuarter': !exists(json, 'developmentStartQuarter') ? undefined : json['developmentStartQuarter'],
        'developmentEndYear': !exists(json, 'developmentEndYear') ? undefined : json['developmentEndYear'],
        'developmentEndQuarter': !exists(json, 'developmentEndQuarter') ? undefined : json['developmentEndQuarter'],
        'salesStartYear': !exists(json, 'salesStartYear') ? undefined : json['salesStartYear'],
        'salesStartMonth': !exists(json, 'salesStartMonth') ? undefined : json['salesStartMonth'],
        'salesEndYear': !exists(json, 'salesEndYear') ? undefined : json['salesEndYear'],
        'salesEndMonth': !exists(json, 'salesEndMonth') ? undefined : json['salesEndMonth'],
        'image': !exists(json, 'image') ? undefined : json['image'],
        'minFloor': !exists(json, 'minFloor') ? undefined : json['minFloor'],
        'maxFloor': !exists(json, 'maxFloor') ? undefined : json['maxFloor'],
        'complex': !exists(json, 'complex') ? undefined : json['complex'],
    };
}

export function HouseToJSON(value?: House | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'title': value.title,
        'type': value.type,
        'street': value.street,
        'number': value.number,
        'facing': value.facing,
        'material': value.material,
        'buildingState': value.buildingState,
        'developmentStartYear': value.developmentStartYear,
        'developmentStartQuarter': value.developmentStartQuarter,
        'developmentEndYear': value.developmentEndYear,
        'developmentEndQuarter': value.developmentEndQuarter,
        'salesStartYear': value.salesStartYear,
        'salesStartMonth': value.salesStartMonth,
        'salesEndYear': value.salesEndYear,
        'salesEndMonth': value.salesEndMonth,
        'image': value.image,
        'minFloor': value.minFloor,
        'maxFloor': value.maxFloor,
        'complex': value.complex,
    };
}

/**
* @export
* @enum {string}
*/
export enum HouseTypeEnum {
    Apartment = 'apartment',
    Office = 'office',
    Parking = 'parking',
    Residential = 'residential'
}


